import { Breakdown } from "@xola/ui-kit";
import React from "react";
import { LineItem, LineItemCode, LineItemType, PurchaseItem } from "types";
import { getColor, getPriceAndQuantity } from "./PaymentBreakdown/utils";

export const DiscountLineItem = ({ lineItem, item }: { lineItem: LineItem; item?: PurchaseItem }) => {
    const isPredefinedLineItemCode = [
        LineItemCode.GIFT_OFFER_DISCOUNT,
        LineItemCode.PACKAGE_DISCOUNT,
        LineItemCode.PARTNER_PACKAGE_DISCOUNT,
    ].includes(lineItem.code);
    const isPredefinedLineItemType = [LineItemType.AFFILIATE_DISCOUNT].includes(lineItem.type);
    const isPredefinedLineItem = isPredefinedLineItemType || isPredefinedLineItemCode;
    const color = getColor(lineItem, item);

    return (
        <Breakdown.Item
            value={lineItem.amount}
            color={color}
            data-testid="discount-line-item"
            classNames={{ children: isPredefinedLineItem ? "" : "no-translate", info: "no-translate" }}
        >
            {lineItem.name} {getPriceAndQuantity(lineItem)}
        </Breakdown.Item>
    );
};
